import {
	COMPONENT_BOOTSTRAPPED,
	COMPONENT_CONNECTED,
	COMPONENT_DISCONNECTED,
	COMPONENT_MODE_DETACH,
	COMPONENT_PROPERTY_CHANGED,
	NOW_MODE_PROP
} from '../../constants';

export function skipForDetachedComponent(host, type, payload) {
	if (host[NOW_MODE_PROP] !== COMPONENT_MODE_DETACH) return false;
	const allowedLifeCycleActions = [
		COMPONENT_CONNECTED,
		COMPONENT_BOOTSTRAPPED,
		COMPONENT_DISCONNECTED
	];
	if (allowedLifeCycleActions.includes(type)) return false;
	if (type !== COMPONENT_PROPERTY_CHANGED) return true;
	return payload.name !== NOW_MODE_PROP;
}
